import { QuantRunBadge } from '@/ui/QuantRunBadge'

/**
 * A run's badge. Shows `canceling` while the server has recorded a Cancel
 * request (`cancel_requested_at`, spec 069 CQ-3) and the run still reads
 * running; the state comes from the server, so a reload keeps it.
 */
export function QuantRunStatusBadge({
  status,
  cancelRequestedAt,
}: {
  status: string
  cancelRequestedAt?: string | null
}) {
  return <QuantRunBadge status={status} canceling={Boolean(cancelRequestedAt) && status === 'running'} />
}
